import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBuildkiteComponent } from './simple-icons-buildkite.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBuildkiteComponent ],
    exports:      [ SimpleIconsBuildkiteComponent ],
    bootstrap:    []
})
export class SimpleIconsBuildkiteModule {}
